import { environment } from '@env/environment';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { InjectionToken, NgZone } from '@angular/core';
import { ɵAngularFireSchedulers } from '@angular/fire';
import { FirebaseOptions } from '@firebase/app';
import { UserService } from '../../services/user.service';
import { filter } from 'rxjs/operators';
import { DriveServiceWorker, ServiceWorkerService } from './service-worker.service';
import { firstValueFrom } from 'rxjs';

/**
 * TODO QFLT-3848 QFLT-4246 Simplify Firebase Messaging Subscription when we subscribe to only one Firebase messaging project
 *
 * This custom implementation can be removed once we subscribe to only one Firebase messaging project.
 * At that point, we can replace it with the default AngularFire implementation as described in the AngularFire
 * documentation: https://github.com/angular/angularfire/blob/main/docs/messaging.md#cloud-messaging
 *
 * Example of the simplified configuration:
 *
 * providers: [
 *   provideFirebaseApp(() => initializeApp({ ... })),
 *   provideMessaging(() => getMessaging()),
 *   ...
 * ],
 *
 * Additionally, we will only need one "default" service worker (e.g. firebase-messaging-sw.js), eliminating the need
 * for the custom code.
 */
export async function firebaseServiceWorker(userService: UserService, serviceWorkerService: ServiceWorkerService) {
  await firstValueFrom(userService.isInitialized$.pipe(filter((isInitialized) => isInitialized)));
  return await serviceWorkerService.register(DriveServiceWorker.NEW_FIREBASE, 'classic');
}

export const newFirebaseMessagingInjectionToken = new InjectionToken<AngularFireMessaging>('newFirebaseMessaging');

export function newFirebaseMessaging(
  platformId: string,
  zone: NgZone,
  serviceWorkerRegistration: Promise<ServiceWorkerRegistration>
) {
  return firebaseMessaging(
    environment.newFirebase,
    'newFirebaseMessaging',
    platformId,
    zone,
    serviceWorkerRegistration
  );
}

function firebaseMessaging(
  options: FirebaseOptions,
  name: string,
  platformId: string,
  zone: NgZone,
  serviceWorkerRegistration: Promise<ServiceWorkerRegistration>
) {
  return new AngularFireMessaging(
    options,
    name,
    platformId,
    zone,
    new ɵAngularFireSchedulers(zone),
    null,
    serviceWorkerRegistration
  );
}
